// import CONSTANTS from "../CONSTANTS";
import users from "../assets/data/credentials.json"
import STATE_LIST from "../assets/json/cityList.json"

// import axios from "axios"

let common = {
    number2text(value) {
        var fraction = Math.round(this.frac(value) * 100);
        var f_text = "";

        if (fraction > 0) {
            f_text = "AND " + this.convert_number(fraction) + " PAISE";
        }

        return this.convert_number(value) + " RUPEE " + f_text + " ONLY";
    },
    frac(f) {
        return f % 1;
    },
    convert_number(number) {
        if ((number < 0) || (number > 999999999)) {
            return "NUMBER OUT OF RANGE!";
        }
        var Gn = Math.floor(number / 10000000);  /* Crore */
        number -= Gn * 10000000;
        var kn = Math.floor(number / 100000);     /* lakhs */
        number -= kn * 100000;
        var Hn = Math.floor(number / 1000);      /* thousand */
        number -= Hn * 1000;
        var Dn = Math.floor(number / 100);       /* Tens (deca) */
        number = number % 100;               /* Ones */
        var tn = Math.floor(number / 10);
        var one = Math.floor(number % 10);
        var res = "";

        if (Gn > 0) {
            res += (this.convert_number(Gn) + " CRORE");
        }
        if (kn > 0) {
            res += (((res === "") ? "" : " ") +
                this.convert_number(kn) + " LAKH");
        }
        if (Hn > 0) {
            res += (((res === "") ? "" : " ") +
                this.convert_number(Hn) + " THOUSAND");
        }

        if (Dn) {
            res += (((res === "") ? "" : " ") +
                this.convert_number(Dn) + " HUNDRED");
        }


        var ones = ["", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE", "TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN"];
        var tens = ["", "", "TWENTY", "THIRTY", "FOURTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"];

        if (tn > 0 || one > 0) {
            if (!(res === "")) {
                res += " AND ";
            }
            if (tn < 2) {
                res += ones[tn * 10 + one];
            }
            else {

                res += tens[tn];
                if (one > 0) {
                    res += ("-" + ones[one]);
                }
            }
        }

        if (res === "") {
            res = "zero";
        }
        return res;
    },
    getRandon(digit) {
        return Math.floor(Math.random() * 1000 * digit);
    }
    , createPayloadForGoogleSheet(data, formdata, user = {}) {
        let obj = {};

        let date = new Date()
        let y = date.getFullYear();
        let m = date.getMonth();
        let d = date.getDate();
        console.log(d, m, y)
        // let y = date.getFullYear();
        obj["Service_Date"] = `${d}-${m + 1}-${y}`
        obj["Engineer"] = formdata.serviceEngineername ? formdata.serviceEngineername : "NA";
        obj["Company"] = formdata.companyName ? formdata.companyName : "NA";
        obj["Company_Address"] = formdata.companyAddress ? formdata.companyAddress : "NA";
        obj["Company_Email"] = formdata.companyEmail ? formdata.companyEmail : "NA";
        obj["Contact_Person"] = formdata.companyContactPerson ? formdata.companyContactPerson : "NA";
        obj["Designation"] = formdata.companyContactPersonDesignation ? formdata.companyContactPersonDesignation : "NA";
        obj["Mobile"] = formdata.companyContactPersonMobile ? formdata.companyContactPersonMobile : "NA";
        obj["Email"] = formdata.companyContactPersonEmail ? formdata.companyContactPersonEmail : "NA";


        return obj
    },
    checkCredentials(obj) {
        let { userName, password } = obj;
        let result = false;

        for (let i = 0; i < users.length; i++) {
            let item = users[i];
            if (
                (item.user_name.toLowerCase() === userName.toLowerCase()) &&
                (
                    ((item.password).toLowerCase() === password.toLowerCase()) ||
                    item.password === password)
            ) {
                result = true;
                localStorage.setItem('user', JSON.stringify(item))
                break;
            }
        }
        return result
    },
    getUsers() {
        return users.map(item => {
            return { ...item, password: "", user_name: "" }
        })
    },
    getGunQuotationKeyval(data) {
        let user = localStorage.getItem('user');
        user = JSON.parse(user)
        let name = (user.first_name ? user.first_name : "") + " " + (user.last_name ? user.last_name : "");

        let date = new Date();
        let obj = {}
        obj['Company_Name'] = data.company_name ? data.company_name : "NA"
        obj['Company_Mobile'] = data.company_mobile ? data.company_mobile : "NA"
        obj['Company_Address'] = data.company_address ? data.company_address : "NA"
        obj['Company_Email'] = data.company_email ? data.company_email : "NA"
        obj['Contact_Person_name'] = data.contact_person_name ? data.contact_person_name : "NA"
        obj['Contact_Person_designation'] = data.contact_person_designation ? data.contact_person_designation : "NA"
        obj['Contact_Person_mobile'] = data.contact_person_mobile ? data.contact_person_mobile : "NA"
        obj['Contact_Person_email'] = data.contact_person_email ? data.contact_person_email : "NA"
        obj['Quantity'] = data.quantity ? data.quantity : "NA"
        obj['Unit_Price'] = data.price ? data.price : "NA"
        obj['Total_Price'] = data.quantity && data.price ? data.quantity * data.price : "NA"

        obj['Generated_By'] = name
        obj['Date'] = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`

        return obj
    },
    getServiceReportKeyVal(data) {
        let user = localStorage.getItem('user');
        user = JSON.parse(user)
        let name = (user.first_name ? user.first_name : "") + " " + (user.last_name ? user.last_name : "");

        let date = new Date();
        let obj = {}
        obj['Company_Name'] = data.company_name ? data.company_name : "NA"
        obj['Company_Mobile'] = data.company_mobile ? data.company_mobile : "NA"
        obj['Company_Address'] = data.company_address ? data.company_address : "NA"
        obj['Company_Email'] = data.company_email ? data.company_email : "NA"
        obj['Contact_Person_name'] = data.contact_person_name ? data.contact_person_name : "NA"
        obj['Contact_Person_designation'] = data.contact_person_designation ? data.contact_person_designation : "NA"
        obj['Contact_Person_mobile'] = data.contact_person_mobile ? data.contact_person_mobile : "NA"
        obj['Contact_Person_email'] = data.contact_person_email ? data.contact_person_email : "NA"
        obj['Quantity'] = data.quantity ? data.quantity : "NA"
        obj['Unit_Price'] = data.price ? data.price : "NA"
        obj['Total_Price'] = data.quantity && data.price ? data.quantity * data.price : "NA"

        obj['Generated_By'] = name
        obj['Date'] = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`

        return obj
    },
    saveDataOnSheet(data, sheetMacroUrl) {
        const formDatab = new FormData();
        Object.keys(data).forEach(key => formDatab.append(key, data[key]))
        console.log(formDatab)
        fetch(sheetMacroUrl, { method: "POST", body: formDatab })
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    checkvalidEmail(email) {
        if (!email) return false;
        if (!email.includes("@")) return false;
        if (!email.split("@")[1].includes(".")) return false;

        return true
    },
    getEmployeeFromLocal() {
        let user = localStorage.getItem("user");
        if (user) {
            return JSON.parse(user)
        } else return false

    },
    getTodayDate(format) {
        let date = new Date();
        let day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
        let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : `0${date.getMonth() + 1}`
        if (format === "dd-mm-yyyy") return `${day}-${month}-${date.getFullYear()}`
        else return `${date.getFullYear()}-${month}-${day}`

    },
    getLoginInfo() {
        let u = localStorage.getItem('user');
        if (u) return JSON.parse(u);
        else return {}
    },
    capitalizeFirstLetter(paragraph) {
        // Split the paragraph into words
        const words = paragraph.split(" ");

        // Initialize an array to store the capitalized words
        const capitalizedWords = [];

        // Iterate through each word and capitalize the first letter
        for (const word of words) {
            const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            capitalizedWords.push(capitalizedWord);
        }

        // Join the capitalized words back into a paragraph
        const capitalizedParagraph = capitalizedWords.join(" ");

        return capitalizedParagraph;
    },
    openInNewTab(url) {
        window.open(url, "_blank")
    },
    slugify(str) {
        return str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '')
    },
    getStateList() {
        let arr = [];
        Object.keys(STATE_LIST).forEach(stateSlug => {
            arr.push({
                ...STATE_LIST[stateSlug],
                key: stateSlug,
                value: STATE_LIST[stateSlug].displayName
            })
        })

        return arr
    },
    getUniqueMobileNumbersFromImData(list) {
        if (!list || !list.length) {
            return []
        }
        let arr = [];
        list.forEach(record => {
            if (record.SENDER_MOBILE) {
                if (record.SENDER_MOBILE.length > 10 && record.SENDER_MOBILE.startsWith("+91")) {
                    arr.push(record.SENDER_MOBILE)
                }
            }
            if (record.SENDER_MOBILE_ALT) {
                if (record.SENDER_MOBILE_ALT.length > 10 && record.SENDER_MOBILE_ALT.startsWith("+91")) {
                    arr.push(record.SENDER_MOBILE_ALT)
                }
            }
            if (record.SENDER_PHONE) {
                if (record.SENDER_PHONE.length > 10 && record.SENDER_PHONE.startsWith("+91")) {
                    arr.push(record.SENDER_PHONE)
                }
            }
            if (record.SENDER_PHONE_ALT) {
                if (record.SENDER_PHONE_ALT.length > 10 && record.SENDER_PHONE_ALT.startsWith("+91")) {
                    arr.push(record.SENDER_PHONE_ALT)
                }
            }
        })

        return arr
    },
    checkMonth() {
        let date = new Date();
        let month = date.getMonth()
        // let is28 = date.setDate(29-date.getDate()).getMonth()===(month+1)
        let is28 = (new Date(date.setDate(29))).getMonth() !== month
        let is29 = (new Date(date.setDate(30))).getMonth() !== month
        let is30 = (new Date(date.setDate(31))).getMonth() !== month
        let is31 = (new Date(date.setDate(32))).getMonth() !== month
        let maxDays = 30;
        if (is28) { maxDays = 28 }
        if (is29) { maxDays = 29 }
        if (is30) { maxDays = 30 }
        if (is31) { maxDays = 31 }
        return maxDays
    },
    addZero(d) {
        if (d.toString().length > 1) {
            d = d + ""
        } else {
            d = `0${d}`
        }
        return d
    },
    getDay(dd) {
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var d = new Date(dd);
        var dayName = days[d.getDay()];
        return dayName
    },
    isSunday(date) {
        let date1 = new Date(date)
        let dn = this.getDay(date1)
        if (dn === "Sunday") {
            return true
        }
        else return false
    },
    refershLocalEmployee() {
        const u = this.getEmployeeFromLocal()
        if(!u){
            return
        }
        const updatedUser = users.find(item=>item.employee_id===u.employee_id)
        if(updatedUser){
            localStorage.setItem("user", JSON.stringify(updatedUser))
        } else{
            localStorage.removeItem("user")
            window.location.reload()
        }
    },
    modifyAttendence(arr) {
        const maxDays = this.checkMonth();
        let date = new Date();
        let arrObj = {};
        let attn = {}
        arr.forEach(item => {
            if (item.date) {
                arrObj[item.date] = item
            }
        })
        console.log(arrObj)
        for (let i = 1; maxDays > i; i++) {
            let d = this.addZero(i)
            let m = this.addZero(date.getMonth() + 1)
            let cnDate = `${date.getFullYear()}-${m}-${d}`
            attn[cnDate] = arrObj[cnDate] || {}
        }
        console.log(attn)
        return attn

        // return { is28, is29, is30, is31 }
    },
    getUniqueById(list){
        let arr = [];
        let uniqId = []
        list.forEach(item=>{
            if(!uniqId.includes(item._id)){
                uniqId.push(item._id)
                arr.push(item)
            }
        })

        return arr
    },
    removeDuplicateService(list){
        let modList = this.getUniqueById(list)
        let arr = [];
        let uniqId = []
        modList.forEach(item=>{
            if(!uniqId.includes(item.service_book_number)){
                uniqId.push(item.service_book_number)
                arr.push(item)
            }
        })

        return arr
    },
    formatDate(date=""){
        if(!date) return ""
        if(date.length>10){
            let full = date.slice(0,10).split("-")
            return `${full[2]}-${full[1]}-${full[0]}`
        }
        return date
    },


    // isServiceReportAllowed
}



export default common